var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import { listIncludedRoles, isRoleAllowedForACL, isRoleInList } from "./utils";
var useAclAccess = /* @__PURE__ */ __name(function useAclAccess2(_ref) {
  var role = _ref.role, resourcePermissions = _ref.resourcePermissions, rolesHierarchy = _ref.rolesHierarchy;
  if (resourcePermissions) {
    var isAllowed = isRoleAllowedForACL(Array.isArray(resourcePermissions) ? resourcePermissions : typeof resourcePermissions === "string" && [resourcePermissions] || resourcePermissions, role, rolesHierarchy);
    return {
      isAllowed
    };
  }
  var allowedRoles = listIncludedRoles(role, rolesHierarchy) || [];
  return {
    allowedRoles,
    checkAclAccess: /* @__PURE__ */ __name(function checkAclAccess(customRole) {
      return isRoleInList(customRole, allowedRoles);
    }, "checkAclAccess")
  };
}, "useAclAccess");
export {
  useAclAccess
};
